const initialState = {
  isLoading: false,
};

export default function reportsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'SALES_REPORT_EXPORT_REQUEST': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'SALES_REPORT_EXPORT_SUCCESS': {
      return {
        ...state,
        isLoading: false,
      };
    }
    case 'SALES_REPORT_EXPORT_FAILURE': {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}
